<template>
  <div class="wrapper">
      <div class="head">反馈意见</div>
      <div class="result-res" v-if="success">
          <p class="p1">发送成功</p>
          <p class="p2">感谢您伴随我们成长！</p>
      </div>
      <div class="result-rej" v-else>
          <p class="p1">发送失败</p>
          <p class="p2">请联系体统管理员！</p>
      </div>
      <div class="back-btn" @click="back">返回</div>
  </div>
</template>

<script>
export default {
    name: '',
    data() {
        return {
            success: ''
        }
    },
    methods: {
        back() {
            this.$router.replace('/home/user/opinion')
        }
    },
    mounted() {
        this.success = Boolean(this.$route.params.success)
    }
}
</script>

<style lang="less" scoped>
    .wrapper{
        width: 100%;
        height: 100%;
        .head{
            height: 40px;
            padding-left: 5px;
            color: #49a2c2;
            border-bottom: 1px solid #49a2c2;
            font-size: 14px;
            line-height: 40px;
            font-weight: bold;
        }
        .result-res, .result-rej{
            margin-top: 60px;
        }
        .result-res p, .result-rej p{
            color: #49a2c2;
            text-align: center;
        }
        .p1{
            font-size: 40px;
        }
        .p2{
            margin-top: 20px;
            font-size: 28px;
        }
        .back-btn{
            width: 80px;
            height: 28px;
            color: #fff;
            border-radius: 5px;
            margin: 50px auto 0;
            background-color: #49a2c2;
            font-size: 12px;
            text-align: center;
            line-height: 28px;
            cursor: pointer;
            user-select: none;
        }
    }
</style>
